import type { GraphpadWidgetConfig } from '@examdojo/math-widget/widgets/graphpad';
import { ContentBlockType, WidgetBlock } from '../../../model';

export const DEFAULT_GRAPHPAD_CONFIG = {
  id: 'default-graphpad',
  type: 'graphpad',
  params: {
    f: { type: 'linear', params: { m: 2, b: -2 } },
  },
  display: {
    coordinateSystem: {
      boundingbox: { xStart: -6, xEnd: 6, yStart: -6, yEnd: 6 },
      grid: { type: 'lines', visible: true },
    },
    elements: { f: {} },
  },
} satisfies GraphpadWidgetConfig;

export const DEFAULT_WIDGET_PROPS: Omit<WidgetBlock, 'id'> = {
  type: ContentBlockType.Widget,
  widget_type: 'graphpad',
  config: DEFAULT_GRAPHPAD_CONFIG,
};
